var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41421 7.00015L13.7072 1.70718L12.293 0.292969L7 5.58594L1.70706 0.292995L0.292844 1.70721L5.58579 7.00015L0.292995 12.2929L1.70721 13.7072L7 8.41436L12.2928 13.7072L13.707 12.293L8.41421 7.00015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLightIcon);
export default __webpack_public_path__ + "static/media/close-light-icon.33beb0f77948cc23b3e5c443c68daa19.svg";
export { ForwardRef as ReactComponent };